<template>
  <div class="dataImport">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24">
        <Breadcrumbs :arr="['碳汇管理平台', '会议/旅游']" />
      </el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search[0]" class="demo-form-inline" v-if="type == 0">
          <el-form-item label="会议名称">
            <el-input size="small" v-model="search[0].meetingName" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item label="主办单位">
            <el-input size="small" v-model="search[0].name" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button size="small" type="primary" @click="getList" round>查询</el-button>
            <el-button size="small" style="margin: 0 0 0 50px" @click="reset" round type="info">重置</el-button>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="search[1]" class="demo-form-inline" v-else-if="type == 1">
          <el-form-item label="姓名/单位">
            <el-input size="small" v-model="search[1].name" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input size="small" v-model="search[1].phone" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <el-form-item label="交通方式">
            <el-select v-model="search[1].transport" clearable placeholder="请选择" size="small">
              <el-option label="公交大巴" :value="0"> </el-option>
              <el-option label="骑行" :value="1"> </el-option>
              <el-option label="航空" :value="2"> </el-option>
              <el-option label="铁路" :value="3"> </el-option>
              <el-option label="水运" :value="4"> </el-option>
              <el-option label="燃油小汽车" :value="5"> </el-option>
              <el-option label="纯电小汽车" :value="6"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round>查询</el-button>
            <el-button size="small" style="margin: 0 0 0 50px" @click="reset" round type="info">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">

        <div class="table_btn">
          <div class="">
            <el-button size="small" :type="type == 0 ? 'primary' : ''" @click="changeTab(0)">会议活动</el-button>
            <el-button size="small" @click="changeTab(1)" :type="type == 1 ? 'primary' : ''">旅游活动</el-button>
          </div>
          <div>
            <el-button size="small" type="primary" @click="isExport()">导出</el-button>
          </div>

        </div>
        <div v-if="type == 0">
          <Tables class="table" :columns="table.columns" :loading="table.loading" :tableData="table.tableData">
			<template slot="startDate" slot-scope="{ row }">
			  <span>{{ row.startDate+' 至 '+row.endDate }}</span>
			</template>
		  </Tables>
          <Paginations :pageData="table.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
        </div>
        <div v-if="type == 1">
          <Tables class="table" :columns="table1.columns" :loading="table1.loading" :tableData="table1.tableData">
            <template slot="transport" slot-scope="{ row }">
              <span>{{ transportLabel(row.transport) }}</span>
            </template>
			
          </Tables>
          <Paginations :pageData="table1.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
        </div>
      </el-col>
    </el-row>
    <el-dialog title="导出" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item id="time" label="选择日期" prop="startDate" class="inlinitem">
          <el-date-picker v-model="form.startDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="inlinitem" prop="endDate">
          <el-date-picker v-model="form.endDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" :picker-options="pickerOptions4" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitExport">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  getActivity,
  getTravelList,
  activityExport,
  travelExport
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue"
import Tables from "@/components/tables/tables.vue"
import Paginations from "@/components/paginations/paginations.vue"
import { columns, columns1 } from "./js/columns"
export default {
  name: "activitiesAndTravels",
  data() {
    return {
      search: [{
        "meetingName": "",
        "name": "",
        "phone": ""
      }, {
        "name": "",
        "phone": "",
        "transport": "",
        "type": ""
      }],
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      // 零碳活动
      table: {
        // 表格展示数据
        tableData: [],
        // 表格显示标题
        columns: [],
        // 表格是否加载中
        loading: false,
        // 分页
        pageData: {
          size: 10,
          page: 1,
          total: 1
        },
      },
      // 零碳出行
      table1: {
        // 表格展示数据
        tableData: [],
        // 表格显示标题
        columns: [],
        // 表格是否加载中
        loading: false,
        // 分页
        pageData: {
          size: 10,
          page: 1,
          total: 1
        },
      },
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 是否显示操作按钮
      isShowView: true,
      //
      type: 0,
      // 导出的弹出
      dialogVisible: false,
      // 校验
      rules: {
        startDate: [{ required: true, message: "选择开始日期" }],
        endDate: [{ required: true, message: "选择结束日期" }],
      },
      // 导出的日期表单
      form: {
        startDate: "",
        endDate: "",
      },
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.startDate) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      // 导出文件名
      fileName: "",
      excel: ''
    }
  },
  methods: {
    // 页面初始化
    init() {
      this.table.columns = columns
      this.table1.columns = columns1
      this.getList()
    },
    transportLabel(val) {
      const map = { 0: '公交大巴', 1: '骑行', 2: '航空', 3: '铁路', 4: '水运', 5: '燃油小汽车', 6: '纯电小汽车' }
      return map[val] !== undefined ? map[val] : ''
    },
    // 获取数据列表
    async getList() {
      let arrTab = [this.table, this.table1]
      let arrFun = [getActivity, getTravelList]
      console.log(arrFun)
      let page = {
        current: arrTab[this.type].pageData.page,
        size: arrTab[this.type].pageData.size,
      };
      arrTab[this.type].loading = true
      const res = await arrFun[this.type](this.search[this.type], page)
      if (res.data.code == 200) {
        arrTab[this.type].tableData = res.data.data.records
        arrTab[this.type].pageData.total = res.data.data.total
      }
      arrTab[this.type].loading = false
    },
    // 点击重置
    reset() {
      if (this.type == 0) {
        this.search[this.type] = {
          "meetingName": "",
          "name": "",
          "phone": ""
        }
      }
      else {
        this.search[this.type] = {
          "name": "",
          "phone": "",
          "transport": "",
          "type": ""
        }
      }
      this.getList()
    },
    changeTab(val) {
      this.type = val
      let arrTab = [this.table, this.table1]
      arrTab[val].tableData = []
      this.getList();
    },
    //
    sizeChange(val) {
      let arrTab = [this.table, this.table1]
      arrTab[this.type].pageData.size = val
      this.getList()
    },
    //
    currentChange(val) {
      let arrTab = [this.table, this.table1]
      arrTab[this.type].pageData.page = val
      this.getList()
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false
    },
    // 导出
    isExport() {
      this.dialogVisible = true;
      this.fileName = ""
      this.form.startDate = ""
      this.form.endDate = ""
      
    },
    // 导出弹出窗关闭
    handleClose(done) {
      this.dialogVisible = false;
    },
    // 导出的提交
    async submitExport() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
        if (this.type == 0) {
          this.fileName = "会议活动"
          const res = await activityExport(this.form)
          if (res.data.type == "application/vnd.ms-excel") {
            this.excel = res.headers['content-disposition']
            this.$message.success("导出成功");
            this.downloadFile(res, this.fileName)
            this.excel = ""
            this.fileName = ""
            this.form.startDate = ""
            this.form.endDate = ""
            this.dialogVisible = false
          } else this.$message.error("筛选范围暂无数据");
        } else {
          this.fileName = "旅游活动"
          const res = await travelExport(this.form)
          if (res.data.type == "application/vnd.ms-excel") {
            this.excel = res.headers['content-disposition']
            this.$message.success("导出成功");
            this.downloadFile(res, this.fileName)
            this.excel = ""
            this.fileName = ""
            this.form.startDate = ""
            this.form.endDate = ""
            this.dialogVisible = false
          } else this.$message.error("筛选范围暂无数据");
        }
      }




    },
    // 下载的方法
    downloadFile(response, fileName) {
      const headers = response.headers;
      const contentType = headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const temp = response.headers['content-disposition'];
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(temp);
      let fileType = '';
      if (matches != null && matches[1]) {
        fileType = matches['input'].substring(matches['input'].lastIndexOf('.'));
      }
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName + fileType; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    }



  },

  mounted() {
    this.init()
  },
  components: {
    Breadcrumbs,
    Tables,
    Paginations,

  },
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.home_main .main_table .table_btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.check-item {
  color: #fff;
  padding: 2px 2px;
  border-radius: 7px;
  background: #409eff;
  border-color: #409eff;
}

.uncheck-item {
  background: #c8c9cc;
  border-color: #c8c9cc;
  color: #fff;
  padding: 2px 2px;
  border-radius: 7px;
}
</style>
